import React from 'react';
import { Routes, Route } from 'react-router-dom'; // ✅ Correct
import { Toaster } from 'react-hot-toast';

import Header from './components/header';
import Footer from './components/footer';
import Hero from './components/hero';
import Classes from './components/classes';
import TestimonialsSection from './components/testimonial';
import OurTracks from './components/ourtrack';
import AboutSection from "./components/AboutSection";
import Notes from './components/notes/notes';
import AddContent from './pages/Admin-Dashboard/AddTopic';
import Preview from './components/pdfViewer/Index';
import DescriptionPage from './components/DescriptionPage';
import ContactSection from './components/ContactPage';
import Gramturestore from './components/GramtureStore';
import Faqs from './components/faqs';
import PrivacyPolicy from './components/privacypolicy';
import ManageProducts from './pages/Admin-Dashboard/ManageContent';
import TopicsSectionsPage from "./components/SectionsTopicsPage"
import DiscussionFourm from './components/DiscussionFourm';
import Ourproud from './components/Topperswall';
import ChatBot from './components/ChatBot';
import NotFound from './components/NotFound';

// Auth and Route Protection
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import Login from './pages/Login';
import Unauthorized from './pages/Unauthorized';
import AdminDashboard from './pages/AdminDashboard';

// Custom CSS variables & Global Theme
import './styles/global.css';

function HomePage() {
  return (
    <>
      <Hero />
      <Classes />
      <OurTracks />
      <TestimonialsSection />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="app-container">
        <Header />
        <main className='main-content'>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutSection />} />
            <Route path="/contact" element={<ContactSection />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />

            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Protected Admin Routes */}
            <Route path="/admin-dashboard" element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            <Route path="/preview" element={<Preview />} />

            <Route path="/description" element={<DescriptionPage />} />
            <Route path="/description/:subCategory/:topicSlug" element={<DescriptionPage />} />

            <Route path="/notes/:selectedClass" element={<Notes />} />
            <Route path="/notes/:selectedClass/:category" element={<Notes />} />
            <Route path="/notes/:selectedClass/:category/:subcategory" element={<Notes />} />
            <Route path="/gramturestore" element={<Gramturestore />} />
            <Route path="/sections/:section" element={<TopicsSectionsPage />} />
            <Route path="/discussionfourm" element={<DiscussionFourm />} />
            <Route path="/ourproud" element={<Ourproud />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <ChatBot />
        <Toaster position="top-right" reverseOrder={false} />
      </div>
    </AuthProvider>
  );
}

export default App;
